//#region DevExtreme Imports

import 'devextreme/ui/popup'
import 'devextreme/ui/select_box'
import 'devextreme/ui/toolbar'

//#endregion

import { SendMailController } from "./send-mail.controller"
import { IMRBaseComponent } from '../base'
import { USER_SESSION_SERVICE_NAME } from '../../../services/user-session'

export const COMPONENT_NAME: string = 'sendMail'

//#region Asset Imports

import './send-mail.scss'
import * as TEMPLATE from './send-mail.tpl.html'

//#endregion

export class SendMailComponent extends IMRBaseComponent {

    constructor() {
        super({
            controller: SendMailController,
            template: TEMPLATE,
            services: [USER_SESSION_SERVICE_NAME]
        })
    }
}
